import { useMutation, useQueryClient } from '@tanstack/react-query';import { axiosInstance } from '@/modules/shared/lib/axios';
import { CountryDetailsModel } from '@/modules/shared/types/country';

export function useMutationCountriesDetails(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Partial<CountryDetailsModel[]>) => {
      const { data } = await axiosInstance.post<CountryDetailsModel[]>(
        `/api/${companyId}/configuration/saveCountryConfiguration`,
        { configuration: payload }
      );
      return data;
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user
      console.error('Error saving countries settings:', error);
    },

    onSuccess: (saved) => {
      queryClient.setQueryData(['config.countriesDetails', companyId], saved);
    },
  });
}
